<template>
    <div class="page">
        <div class="systemList">
            <!--<div class="systemItem" @click="$router.push({name:'AirQuality'})">-->
            <!--<div class="icon el-icon-s-flag"></div>-->
            <!--<div class="text">宿州市天蓝卫士系统</div>-->
            <!--</div>-->
            <!--<div class="systemItem" @click="$router.push({name:'VOCSystemHome'})">-->
            <!--<div class="icon el-icon-s-management"></div>-->
            <!--<div class="text"> VOC系统</div>-->
            <!--</div> -->
            <template v-if="menuList&& menuList.length>0">
                <div class="systemItem" v-for="item in menuList" :key="item.id" @click="jump(item.url)">
                    <div class="icon" :class="item.icon"></div>
                    <div class="text"> {{item.name}}</div>
                </div>
            </template>
            <!--<template v-else>-->
            <!--<div class="systemItem" @click="$router.push({name:'AirQuality'})">-->
            <!--<div class="icon el-icon-s-flag"></div>-->
            <!--<div class="text">宿州市天蓝卫士系统</div>-->
            <!--</div>-->
            <!--</template>-->
        </div>

        <el-dialog
                title="选择切换城市"
                :visible.sync="openChangeCityCol"
                width="300px"
                >
            <div>
                <el-form :model="ruleForm" :rules="rules" size="mini" inline-message ref="ruleForm" label-width="0" class="demo-ruleForm">
                    <el-form-item  prop="cityCode">
                        <el-select v-model="ruleForm.cityCode" placeholder="请选择城市">
                            <el-option v-for="item in cityList" :key="item.city" :label="item.city" :value="item.cityCode"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import apiUrl from "../utils/UrlApi"

    export default {
        name: "systemSelection",
        created() {
            this.handleMenu()
            this.getCityList()
        },
        computed:{
            cityList: {
                get() {
                    return this.$store.state.optionCityList
                },
                set(val) {
                    this.$store.commit('updateoptionCityList', val)
                }
            },
        },
        data() {
            return {
                menuList: [],
                openChangeCityCol:false,
                ruleForm: {
                    cityCode: '',
                },
                rules: {
                    cityCode: [
                        { required: true, message: '请选择切换城市', trigger: 'change' }
                    ],
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.setCity()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //   切换城市
            setCity(){
                let datas = {
                    cityCode: this.ruleForm.cityCode
                }
                this.$http.post(apiUrl.setRoleCity, datas
                ).then(({data}) => {
                        if (data.code === '200') {
                            this.jumpHuishang()
                            this.openChangeCityCol =false
                        }
                    }
                )
            },


            jumpHuishang(){
                this.$http.get(apiUrl.gzDataToken, {
                    params: {}
                }).then(res => {
                    if (res.data.code === '200') {
                        // this.openChangeCityCol =false
                        let urls = `https://dst.cleanair.work/project-brow?id=${res.data.data.id}&token=` + res.data.data.token
                        window.open(urls, '_blank')
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            //  跳转专家会商
            getCityList() {
                let data = {}
                this.$http.get(apiUrl.roleCity, {
                    params: data
                }).then(res => {
                    this.cityList = res.data.data
                })
            },
            handleMenu() {
                let data = {}
                this.$http.get(apiUrl.sysMenuNav, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.menuList = res.data.data.menuList
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            jump(routerName) {
                //  成因分析 菜单 路由单独处理
                if (routerName === 'webConsultation') {
                    this.openChangeCityCol = true
                } else {
                    this.$router.push({name: routerName})
                }
                // if (routerName === 'AirQuality') {
                //     let data = this.$store.getters.getCauseAnalysisData[0];
                //
                //     this.$store.commit("updateCauseAnalysisSelect", data.menuId);
                //     this.$router.push("/cause-analysis/"+data.menuId);
                // this.$router.push({
                //     name: 'CauseAnalysis',
                //     query: {id: data.menuId}
                // });
                // } else {
                // this.$router.push({name: routerName})

                // }
            }
        }
    }
</script>

<style scoped lang="less">
    .page {
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        background: url("../assets/images/new_homeBg.jpg") no-repeat;
        /*background-size: 100% 100%;*/
        background-size: cover;
        background-position: center;
        align-items: center;
        justify-content: center;

        .systemList {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            padding: 10px;

            .systemItem {
                color: #fff;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px;
                transition: all .5s;
                box-sizing: border-box;
                cursor: pointer;
                margin-right: 20px;
                flex: 1;
                min-width: 300px;

                .icon {
                    width: 100px;
                    height: 100px;
                    border: 1px solid #fff;
                    font-size: 50px;
                    text-align: center;
                    line-height: 100px;
                    border-radius: 20px;
                }

                .text {
                    text-align: center;
                    font-size: 26px;
                    margin-top: 20px;
                }
            }

            .systemItem:hover {
                /*border: 1px solid #1daaf1;*/

                .icon {
                    color: #1daaf1;
                    border: 1px solid #1daaf1;
                }

                .text {
                    color: #1daaf1;
                }
            }

            :last-child {
                margin-right: 0px;

            }
        }
    }

</style>